import { navigate } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import Breadcrumb from '@ui/atoms/Breadcrumb';
import Button from '@ui/atoms/Button';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';
import DashedLinkButton from '@ui/molecules/DashedLinkButton';

import fullWidth from '@ui/styled/FullWidth';
import spaced from '@ui/styled/Spaced';

import useMemberInsurance, { IInsurance } from '@hooks/useMemberInsurance';

import { maskInsurance } from '@helpers/Insurance/maskInsurance';

interface IInsuranceCoverageStepProps {
	pageContent: IInsuranceCoverageStepContent;
}

export interface IInsuranceCoverageStepContent {
	title: string;
	breadcrumbLabel: string;
	emptyInsuranceText: string;
	addNewPlanLabel: string;
}

const InsuranceCardContainer = styled.div`
	border: 0.2rem solid #000000;
	border-radius: 0.8rem;
	padding: 2.4rem;
	text-align: left;
`;

const UpdateButton = styled(Button)`
	width: auto;
	border-radius: 2.4rem;
`;

const FullWidthColumn = fullWidth<IFlexColumn>(FlexColumn);
const SpacedColumn = spaced<IFlexColumn>(FullWidthColumn);

const InsuranceCoverageStep: FC<IInsuranceCoverageStepProps> = ({ pageContent }) => {
	const { title, breadcrumbLabel, emptyInsuranceText, addNewPlanLabel } = pageContent;

	const { memberInsurance } = useMemberInsurance(false, 'network-only');

	return (
		<CenteredGridItem>
			<SpacedColumn gap="sm" marginBottom="lg">
				<Breadcrumb label={breadcrumbLabel} href="../.." />
				<HeadingText>{title}</HeadingText>
				{!(memberInsurance && memberInsurance.length > 0) && (
					<BasicText>{emptyInsuranceText}</BasicText>
				)}
			</SpacedColumn>
			<SpacedColumn gap="md" marginBottom="md">
				{memberInsurance &&
					memberInsurance.map((insurance: IInsurance, index) => (
						<InsuranceCardContainer key={index}>
							<SpacedColumn gap="xs" marginBottom="md">
								<BasicText variant="fineprintBold">{insurance.insuranceProviderName}</BasicText>
								<BasicText>{maskInsurance(insurance.memberInsuranceId)}</BasicText>
							</SpacedColumn>
							<UpdateButton
								labelSize="xs"
								label="Update"
								onClick={() => navigate(`../${insurance.id}/insurance_details_edit`)}
							/>
						</InsuranceCardContainer>
					))}
				{memberInsurance && memberInsurance.length < 5 && (
					<DashedLinkButton href="../provider" label={addNewPlanLabel} />
				)}
			</SpacedColumn>
		</CenteredGridItem>
	);
};

export default InsuranceCoverageStep;
